<template>
  <div class="card p-4">
    <h4>Tags do Curso</h4>
    <tags-input
      v-model="tag"
      :tags="tags"
      :autocomplete-items="filteredItems"
      placeholder="Adicionar Tags ao curso"
      @tags-changed="( newTags ) => setTags( newTags )"
    />
    <div class="col-12 text-right mt-3">
      <button class="btn btn-success" @click="save">Salvar Tags</button>
    </div>
  </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import Axios from 'axios';

export default {
  components: {
    "tags-input": VueTagsInput
  },
  props: {
    tags: {
      required: true
    },
    course: {
      required: true
    }
  },
  data () {
    return {
      tag: "",
      autocompleteItems: []
    }
  },
  computed: {
    filteredItems () {
      return this.autocompleteItems.filter(item => {
        return item.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
    }
  },
  methods: {
    getTags: function () {
      Axios.get('/tags')
        .then( res => {
          this.autocompleteItems = res.data.data
        })
    },

    setTags: function ( tag ) {
      this.tags = tag
    },

    save: function () {
      Axios.post('/teacher/course/tag', {
        course: this.course,
        tags: this.tags
      })
        .then( res => {
          Swal.fire({
            icon: 'success',
            text: 'Informações deletada',
            title: 'Sucesso'
          })
          this.load()
        })
        .catch( err => {
          console.error( err )
        })
    }
  },
  mounted() {
    this.getTags()
  }
}
</script>
